import React from 'react';
import moment from 'moment';
import NullMessage from "../../../../components/NullMessage";
import Table from "../../../../components/Table";
import ObservationFilters from "../ObservationFilters";
import { Comments } from './style.js';
import _ from "lodash";

export default class ObservationComments extends React.Component {
  render(){
    return (
      <Comments id="comments-tab" key="comments-tab">
        <ObservationFilters
          handleStateChange={this.handleStateChange}
          {...this.props}
        />
        { this.props.state.observations.length > 0 ?
          <Table columns={['Date', 'Observer Name', 'Observation Area', 'Domain', 'Rating', 'Comment']}>
            {this.props.state.observations.map((observation, index) => {
              let top = 'Briefing';
              const domainFilter = this.props.state.domains.length > 0;
              const ratingFilter = this.props.state.ratings.length > 0;
              const showBrief = (!domainFilter || _.includes(this.props.state.domains, 'Briefing')) && (!ratingFilter || _.includes(this.props.state.ratings, observation.briefRate));
              const showInq = (!domainFilter || _.includes(this.props.state.domains, 'Inquiry & Rebriefing')) && (!ratingFilter || _.includes(this.props.state.ratings, observation.inqRate));
              const showAssert = (!domainFilter || _.includes(this.props.state.domains, 'Assertion & Challenge')) && (!ratingFilter || _.includes(this.props.state.ratings, observation.assertRate));
              const showStruc = (!domainFilter || _.includes(this.props.state.domains, 'Structured Communication')) && (!ratingFilter || _.includes(this.props.state.ratings, observation.struccomRate));
              const showLoop = (!domainFilter || _.includes(this.props.state.domains, 'Closing the Loop')) && (!ratingFilter || _.includes(this.props.state.ratings, observation.loopRate));
              const showDebrief = (!domainFilter || _.includes(this.props.state.domains, 'Debriefing')) && (!ratingFilter || _.includes(this.props.state.ratings, observation.debriefRate));
              if (showBrief) {
                top = 'Briefing';
              } else if (showInq) {
                top = 'Inquiry & Rebriefing';
              } else if (showAssert) {
                top = 'Assertion & Challenge';
              } else if (showStruc) {
                top = 'Structured Communication';
              } else if (showLoop) {
                top = 'Closing the Loop';
              } else if (showDebrief) {
                top = 'Debriefing';
              }
              return ([
                <tr id={`row-${index}-brief`} key={`row-${index}-brief`} className={`no-hover merge-down ${!showBrief && 'hide'}`}>
                  <td data-label="Date:">{moment(observation.obsDate).format('MM/DD/YY')}</td>
                  <td data-label="Observer Name:" className="no-wrap">{observation.obsName}</td>
                  <td data-label="Observation Area:" className="no-wrap">{observation.obsArea}</td>
                  <td data-label="Domain:" className="no-wrap">Briefing</td>
                  <td data-label="Rating:" className="center">{observation.briefRate}</td>
                  <td data-label="Comment:">{observation.briefDesc}</td>
                </tr>,
                <tr id={`row-${index}-inq`} key={`row-${index}-inq`} className={`no-hover ${top === 'Inquiry & Rebriefing' ? 'merge-down' : 'merge-up'} ${!showInq && 'hide'}`}>
                  { top === 'Inquiry & Rebriefing' ? <td data-label="Date:">{moment(observation.obsDate).format('MM/DD/YY')}</td> : <td/> }
                  { top === 'Inquiry & Rebriefing' ? <td data-label="Observer Name:" className="no-wrap">{observation.obsName}</td> : <td/> }
                  { top === 'Inquiry & Rebriefing' ? <td data-label="Observation Area:" className="no-wrap">{observation.obsArea}</td> : <td/> }
                  <td data-label="Domain:" className="no-wrap">Inquiry & Rebriefing</td>
                  <td data-label="Rating:" className="center">{observation.inqRate}</td>
                  <td data-label="Comment:">{observation.inqDesc}</td>
                </tr>,
                <tr id={`row-${index}-assert`} key={`row-${index}-assert`} className={`no-hover ${top === 'Assertion & Challenge' ? 'merge-down' : 'merge-up'} ${!showAssert && 'hide'}`}>
                  { top === 'Assertion & Challenge' ? <td data-label="Date:">{moment(observation.obsDate).format('MM/DD/YY')}</td> : <td/> }
                  { top === 'Assertion & Challenge' ? <td data-label="Observer Name:" className="no-wrap">{observation.obsName}</td> : <td/> }
                  { top === 'Assertion & Challenge' ? <td data-label="Observation Area:" className="no-wrap">{observation.obsArea}</td> : <td/> }
                  <td data-label="Domain:" className="no-wrap">Assertion & Challenge</td>
                  <td data-label="Rating:" className="center">{observation.assertRate}</td>
                  <td data-label="Comment:">{observation.assertDesc}</td>
                </tr>,
                <tr id={`row-${index}-struccom`} key={`row-${index}-struccom`} className={`no-hover ${top === 'Structured Communication' ? 'merge-down' : 'merge-up'} ${!showStruc && 'hide'}`}>
                  { top === 'Structured Communication' ? <td data-label="Date:">{moment(observation.obsDate).format('MM/DD/YY')}</td> : <td/> }
                  { top === 'Structured Communication' ? <td data-label="Observer Name:" className="no-wrap">{observation.obsName}</td> : <td/> }
                  { top === 'Structured Communication' ? <td data-label="Observation Area:" className="no-wrap">{observation.obsArea}</td> : <td/> }
                  <td data-label="Domain:" className="no-wrap">Structured Communication</td>
                  <td data-label="Rating:" className="center">{observation.struccomRate}</td>
                  <td data-label="Comment:">{observation.struccomDesc}</td>
                </tr>,
                <tr id={`row-${index}-loop`} key={`row-${index}-loop`} className={`no-hover ${top === 'Closing the Loop' ? 'merge-down' : 'merge-up'} ${!showLoop && 'hide'}`}>
                  { top === 'Closing the Loop' ? <td data-label="Date:">{moment(observation.obsDate).format('MM/DD/YY')}</td> : <td/> }
                  { top === 'Closing the Loop' ? <td data-label="Observer Name:" className="no-wrap">{observation.obsName}</td> : <td/> }
                  { top === 'Closing the Loop' ? <td data-label="Observation Area:" className="no-wrap">{observation.obsArea}</td> : <td/> }
                  <td data-label="Domain:" className="no-wrap">Closing the Loop</td>
                  <td data-label="Rating:" className="center">{observation.loopRate}</td>
                  <td data-label="Comment:">{observation.loopDesc}</td>
                </tr>,
                <tr id={`row-${index}-debrief`} key={`row-${index}-debrief`} className={`no-hover ${top === 'Debriefing' ? 'merge-down' : 'merge-up'} ${!showDebrief && 'hide'}`}>
                  { top === 'Debriefing' ? <td data-label="Date:">{moment(observation.obsDate).format('MM/DD/YY')}</td> : <td/> }
                  { top === 'Debriefing' ? <td data-label="Observer Name:" className="no-wrap">{observation.obsName}</td> : <td/> }
                  { top === 'Debriefing' ? <td data-label="Observation Area:" className="no-wrap">{observation.obsArea}</td> : <td/> }
                  <td data-label="Domain:" className="no-wrap">Debriefing</td>
                  <td data-label="Rating:" className="center">{observation.debriefRate}</td>
                  <td data-label="Comment:">{observation.debriefDesc}</td>
                </tr>,
              ]);
            })}
          </Table>
          :
          <NullMessage> No Comments </NullMessage>
        }
      </Comments>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Observations/components/ObservationComments/index.jsx